import React from "react";
import IndiaMap from "./IndiaMap";

export default function FutureMobility() {
  return (
    <section
      id="future-mobility"
      data-testid="future-mobility-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div className="eco-blob bg-eco-light" style={{ width: 600, height: 600, top: "20%", left: "-10%", opacity: 0.18 }} />
      <div className="eco-blob bg-saffron" style={{ width: 360, height: 360, bottom: "0%", right: "-5%", opacity: 0.12 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 reveal">
            <span className="overline">Future Mobility</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mt-5 leading-[1.05] tracking-tight">
              A living grid,
              <br />
              <span className="gradient-text-eco">across Bharat.</span>
            </h2>
            <p className="mt-7 text-white/65 text-base md:text-lg leading-relaxed">
              Our nationwide network will connect biofuel depots, EV super-chargers and renewable plants
              into one intelligent energy mesh — flowing power, data and clean fuel from Kashmir to Kanyakumari.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-5">
              {[
                { k: "28+", v: "States Covered" },
                { k: "850+", v: "Charging Nodes" },
                { k: "12", v: "Mega Refineries" },
                { k: "100%", v: "Green Sourced" },
              ].map((s, i) => (
                <div key={i} className="border-l border-eco-light/30 pl-4">
                  <div className="font-display text-3xl font-bold gradient-text-saffron">{s.k}</div>
                  <div className="text-sm text-white/50 mt-1">{s.v}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="glass-card p-6 md:p-10 grain relative" data-testid="india-map-card">
              <div className="india-map-shell">
                <IndiaMap />
              </div>
              {/* Legend */}
              <div className="mt-6 flex flex-wrap justify-center gap-4 sm:gap-5 text-xs text-white/60">
                <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full" style={{ background: "#138808", boxShadow: "0 0 10px #138808" }} /> Bio-Fuel Hubs</div>
                <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full" style={{ background: "#FF9933", boxShadow: "0 0 10px #FF9933" }} /> EV Super-Chargers</div>
                <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full" style={{ background: "#4FB3FF", boxShadow: "0 0 10px #4FB3FF" }} /> Renewable Plants</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
